export const DEFAULT_WATER_PRICE = { dist: 2.5, sewage: 2.0 };

/**
 * Pour chaque usage actif : eau économisée = volume annuel × couverture de la cuve choisie
 * (fiabilité obtenue à l'étape 5). Le tarif appliqué dépend de `usage.sewage` : si l'eau
 * part à l'égout (WC, lave-linge), l'eau de pluie n'évite que la part distribution — l'eau
 * usée part quand même au traitement, donc l'assainissement reste dû (typiquement recouvré
 * via le compteur volumétrique déclaré à la collectivité). Si l'usage n'est pas raccordé
 * (jardin, lavage extérieur), les deux parts (distribution + assainissement) sont économisées.
 */
export const computeUsageSavings = (usages, coverage, priceDist, priceSewage) => {
  const priceTotal = priceDist + priceSewage;
  const activeUsages = usages.filter(u => u.enabled);

  const rows = activeUsages.map(u => {
    const savedM3 = u.volume * coverage;
    const rate = u.sewage ? priceDist : priceTotal;
    const eurosSaved = savedM3 * rate;
    return { id: u.id, name: u.name, volume: u.volume, sewage: u.sewage, savedM3, rate, eurosSaved };
  });

  const totalWaterSavedM3 = rows.reduce((sum, r) => sum + r.savedM3, 0);
  const totalEurosSaved = rows.reduce((sum, r) => sum + r.eurosSaved, 0);

  return { rows, totalWaterSavedM3, totalEurosSaved };
};

/**
 * @returns {{ paybackLowYears: number, paybackHighYears: number }|null} null si aucune
 *   économie annuelle n'est calculable (pas de cuve choisie, ou aucun usage actif).
 */
export const computePayback = (totalEurosSaved, budgetTotalLow, budgetTotalHigh) => {
  if (totalEurosSaved <= 0) return null;
  return {
    paybackLowYears: budgetTotalLow / totalEurosSaved,
    paybackHighYears: budgetTotalHigh / totalEurosSaved,
  };
};
